/* French labels for app-generated accessibility UI; review and consent text stay unchanged. */
(() => {
  'use strict';
  if (document.documentElement.lang.toLowerCase().split('-')[0] !== 'fr') return;

  const carouselSelector = '.ss-proof__reviews #shopify-block-AMnRXaC9LVVNETGwxW__judge_me_reviews_cards_carousel_9YzFEL .jdgm-widget.jdgm-cards-carousel';
  const cookieSelector = '#tinycookie-preferences-wrapper';
  const targetSelector = carouselSelector + ', ' + cookieSelector;
  const ratingPattern = /^([0-9]+(?:[.,][0-9]+)?) out of 5 stars$/;
  const localObservers = new Map();
  let discoveryObserver = null;

  function patch(target) {
    if (target.matches(cookieSelector)) {
      for (const close of target.querySelectorAll('.tinycookie-preferences-header > .tinycookie-preferences-close[aria-label="Close"]')) {
        close.setAttribute('aria-label', 'Fermer');
      }
      return;
    }
    if (!target.matches(carouselSelector) || document.body.dataset.ssPageType !== 'index') return;
    for (const arrow of target.querySelectorAll('.jdgm-content > button.jdgm-arrow[aria-label]')) {
      const label = arrow.getAttribute('aria-label');
      if (label === 'Previous slide') arrow.setAttribute('aria-label', 'Avis précédent');
      else if (label === 'Next slide') arrow.setAttribute('aria-label', 'Avis suivant');
    }
    for (const stars of target.querySelectorAll('.jdgm-average-rating > .jdgm-stars[role="img"][aria-label]')) {
      const match = stars.getAttribute('aria-label').match(ratingPattern);
      if (match) stars.setAttribute('aria-label', match[1].replace('.', ',') + ' sur 5 étoiles');
    }
  }

  function attach(target) {
    if (localObservers.has(target)) return;
    if (target.matches(carouselSelector) && document.body.dataset.ssPageType !== 'index') return;
    const observer = new MutationObserver(() => patch(target));
    observer.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
    localObservers.set(target, observer);
    patch(target);
  }

  function discover(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(targetSelector)) attach(node);
    for (const target of node.querySelectorAll(targetSelector)) attach(target);
  }

  function stop() {
    discoveryObserver?.disconnect();
    for (const observer of localObservers.values()) observer.disconnect();
    localObservers.clear();
  }

  function start() {
    stop();
    for (const target of document.querySelectorAll(targetSelector)) attach(target);
    discoveryObserver = new MutationObserver(records => {
      let removed = false;
      for (const record of records) {
        for (const node of record.addedNodes) discover(node);
        if (record.removedNodes.length) removed = true;
      }
      if (removed) {
        for (const [target, observer] of localObservers) {
          if (!target.isConnected) { observer.disconnect(); localObservers.delete(target); }
        }
      }
    });
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
  }

  start();
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', event => { if (event.persisted) start(); });
})();
